import styled from 'styled-components';

import { Breadcrumb } from 'ui/breadcrumb';
import { PAGE_HEADER_VARIANTS } from 'ui/pageHeader/constants';
import { spacing } from 'ui/theme';

import { usePanelContext } from '../../contexts/Panel';
import { useTranslations } from '../../hooks/useTranslations';
import { PanelView } from '../../types';
import { UrlInput } from './UrlInput';

const RemoteUrlViewBody = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  height: 100%;
  row-gap: ${spacing.base};
`;

const ControlSection = styled.section`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.half};
  > *:first-child > div {
    margin-bottom: 0;
  }
`;

export const testIds = {
  breadcrumb: 'cl-panel-remote-url-breadcrumb',
};

export const PanelViewRemoteUrl = () => {
  const { t } = useTranslations();
  const { setPanelView } = usePanelContext();

  return (
    <RemoteUrlViewBody>
      <ControlSection data-test={testIds.breadcrumb}>
        <Breadcrumb
          breadcrumb={{
            content: t('link.imageLibrary'),
            onClick: () => setPanelView(PanelView.List),
          }}
          isButton
          variant={PAGE_HEADER_VARIANTS.SECONDARY}
        />
      </ControlSection>
      <UrlInput />
    </RemoteUrlViewBody>
  );
};
